import ApiService from './api.service'

const LogService = {        
    get(id, userName, comapnyName, logActionId, logObjectId, searchString, page, count) {
        return ApiService.get('/api/logs', {
            params: {
              Id: id,
              UserName: userName,
              ComapnyName: comapnyName,
              LogActionId: logActionId,
              LogObjectId: logObjectId,
              SearchString: searchString,
              Page: page,
              Count: count
            }
        })
    },
    getActions() {
        return ApiService.get('/api/logs/actions')
    },
    getObjects() {
        return ApiService.get('/api/logs/objects')
    }
}

export default LogService